export default "__VITE_ASSET__T85ysIcW__"